import { Button, Grid } from "@mui/material";
import React from "react";
import featuresImage from "../../assets/Images/featuresImage.svg";
import dataSecurity from "../../assets/Images/dataSecurity.svg";
import servicestraining from "../../assets/Images/servicestraining.svg";
import residentIcon from "../../assets/Images/residentIcon.svg";
import EventPolls from "../../assets/Images/EventPolls.svg";
import simpleAcc from "../../assets/Images/simpleAcc.svg";
import smoothOnboard from "../../assets/Images/smoothOnboard.svg";
import guardSecurity from "../../assets/Images/guardSecurity.svg";
import support from "../../assets/Images/support.svg";
import adminModule from "../../assets/Images/adminModule.svg";
import residentModule from "../../assets/Images/residentModule.svg";
import guardModule from "../../assets/Images/guardModule.svg";
import bannertoplayer1 from "../../assets/Images/bannertoplayer1.svg";
import bannertoplayer2 from "../../assets/Images/bannertoplayer2.svg";
import bannertoplayer3 from "../../assets/Images/bannertoplayer3.svg";

import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// slider second
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

// Slide start
// import { useTheme } from "@mui/material/styles";
// import SwipeableViews from "react-swipeable-views";
// import { autoPlay } from "react-swipeable-views-utils";
import HomeTop from "./HomeTop";
import HomeFooter from "./HomeFooter";
import { useFormik } from "formik";
import * as Yup from "yup";
import { makePostRequest } from "../../utils/utils";
import plane from "../../../src/assets/Images/palne.jpg";
import Marquee from 'react-fast-marquee';

function HomePage() {
  const navigate = useNavigate();
  // const [formData, setFormData] = useState({
  //   fullName: "",
  //   mobileNumber: "",
  //   email: "",
  //   societyName: "",
  //   location: "",
  //   city: "",
  // });

  const handleFormSubmit = async (values, { resetForm }) => {
    // e.preventDefault();
    console.log("Form Submitted:", values);
    await makePostRequest("commonapis/contact_requests", values)
      .then((response) => {
        if (response.data.data !== undefined) {
          swal("Success", "Request Submitted Successfully", "success", {
            timer: 1000,
            buttons: false,
          });
          resetForm();
        } else {
        }
      })
      .catch((err) => {
        console.log("in catch");
        swal("There was an error!", err, "warning");
      });
  };

  const formik = useFormik({
    initialValues: {
      full_name: "",
      mobile_number: "",
      emailid: "",
      society_name: "",
      location: "",
      city: "",
    },
    validationSchema: Yup.object({
      full_name: Yup.string().required("Full Name is required"),
      mobile_number: Yup.string()
        .matches(/^[0-9]+$/, "Mobile number must be digits only")
        .min(10, "Must be at least 10 digits")
        .required("Mobile Number is required"),
      emailid: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      society_name: Yup.string().required("Society Name is required"),
      location: Yup.string().required("Location is required"),
      city: Yup.string().required("City is required"),
    }),
    onSubmit: handleFormSubmit,
  });

  return (
    <>
      <HomeTop />
      <div className="bannerMain whiteBG">
        <div className="planIm">
          <Marquee
            speed={50}
            pauseOnHover
            gradient={false}
            aria-label="Announcement"
          >
            {" "}
            <img src={plane} alt="" />
          </Marquee>
        </div>
        <div className="container">
          <div className="bannerContent">
            <h1>Smart Living Made Simple</h1>
            <p style={{ zIndex: 3 }}>
              Manage your society effortlessly with our state-of-the-art society
              management software.
            </p>
          </div>
        </div>
        <div className="bannerImOuter">
          <img className="bannertoplayer1" src={bannertoplayer1} />
          <img className="bannertoplayer2" src={bannertoplayer2} />
          <img className="bannertoplayer3" src={bannertoplayer3} />
        </div>
      </div>
      <div className="sectionMain whiteBG">
        <div className="featuresImageMain">
          <div className="container">
            <p className="sectionSubHeading">
              Leverage Resipro for a secure and harmonious community living
              experience.
            </p>
          </div>
          <div className="featuresImageContent">
            <div className="featuresOuter">
              <div className="featuresImgLeftContent">
                <h5>Notice Board</h5>
                <div className="featuresImgOuter">
                  <img src={dataSecurity} />
                </div>
              </div>
              <div className="featuresImgLeftContent">
                <h5>Complaints</h5>
                <div className="featuresImgOuter">
                  <img src={servicestraining} />
                </div>
              </div>
              <div className="featuresImgLeftContent">
                <h5>Resident Management</h5>
                <div className="featuresImgOuter">
                  <img src={residentIcon} />
                </div>
              </div>
              <div className="featuresImgLeftContent">
                <h5>Event/Polls</h5>
                <div className="featuresImgOuter">
                  <img src={EventPolls} />
                </div>
              </div>
            </div>

            <div className="featuresOuter">
              <img src={featuresImage} />
            </div>
            <div className="featuresOuter">
              <div className="featuresImgLeftContent featuresImgRightContent">
                <div className="featuresImgOuter featuresImgOuterRight">
                  <img src={simpleAcc} />
                </div>
                <h5>Maintenance Invoices</h5>
              </div>
              <div className="featuresImgLeftContent featuresImgRightContent">
                <div className="featuresImgOuter featuresImgOuterRight">
                  <img src={smoothOnboard} />
                </div>
                <h5>Service Providers Management</h5>
              </div>
              <div className="featuresImgLeftContent featuresImgRightContent">
                <div className="featuresImgOuter featuresImgOuterRight">
                  <img src={guardSecurity} />
                </div>
                <h5>Visitor Management</h5>
              </div>
              <div className="featuresImgLeftContent featuresImgRightContent">
                <div className="featuresImgOuter featuresImgOuterRight">
                  <img src={support} />
                </div>
                <h5>Support Tickets</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sectionMain greyBG">
        <div className="container">
          <div className="webMainModules">
            <h3 className="sectionHeading alignLeft">ResiPro Modules</h3>
            <p className="sectionSubHeading alignLeft marginBottom">
              Our modules are designed with simplicity in mind, ensuring that
              managing your society is a breeze. Seamless, user-friendly
              features that make daily tasks easier and more efficient.
            </p>
            <Grid container spacing={5}>
              <Grid item xs={12} md={6}>
                <div className="moduleOuter">
                  <div className="moduleImage  moduleimgPadding">
                    <img src={adminModule} />
                  </div>
                  <h3>Admin Application</h3>
                  <p>
                    The Admin Module offers comprehensive control over community
                    operations, managing resident information, maintenance
                    requests, and resident...
                  </p>
                  <a onClick={() => navigate("/AdminFeatures")}>Read More</a>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="moduleOuter">
                  <div className="moduleImage">
                    <img src={residentModule} />
                  </div>
                  <h3>Resident Application</h3>
                  <p>
                    The Owner/Tenant module in society management software
                    allows for efficient management of resident information,
                    lease agreements,...
                  </p>
                  <a onClick={() => navigate("/ResidentFeatures")}>Read More</a>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="moduleOuter">
                  <div className="moduleImage">
                    <img src={guardModule} />
                  </div>
                  <h3>Security Application</h3>
                  <p>
                    Our Security module in a ResiPro facilitates efficient
                    management of security personnel and gatekeeping operations.
                    It includes...
                  </p>
                  <a onClick={() => navigate("/GuardFeatures")}>Read More</a>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <div className="sectionMain whiteBG paddingBMinus">
        <div className="societyStatistics">
          <div className="container">
            <Grid container spacing={4}>
              <Grid item xs={3}>
                <div className="statContent">
                  <h4>10+</h4>
                  <p>Societies Registered</p>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className="statContent">
                  <h4>100+</h4>
                  <p>Authorized Visitor Entries </p>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className="statContent">
                  <h4>300+</h4>
                  <p>Invoices Generated</p>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className="statContent">
                  <h4>20+</h4>
                  <p>Guards Managed</p>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <div className="contactFormMain">
        <div className="sectionMain">
          <div className="container">
            <div className="contactForm">
              <h1 className="sectionHeading" style={{ color: "#ffffff" }}>
                Connect With Us
              </h1>
              <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <input
                      className="contactInput"
                      name="full_name"
                      placeholder="Full Name"
                      value={formik.values.full_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.full_name && formik.errors.full_name && (
                      <div className="errorField">
                        {formik.errors.full_name}
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <input
                      className="contactInput"
                      name="mobile_number"
                      placeholder="Mobile Number"
                      value={formik.values.mobile_number}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.mobile_number &&
                      formik.errors.mobile_number && (
                        <div className="errorField">
                          {formik.errors.mobile_number}
                        </div>
                      )}
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <input
                      className="contactInput"
                      name="emailid"
                      placeholder="Email Address"
                      value={formik.values.emailid}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.emailid && formik.errors.emailid && (
                      <div className="errorField">{formik.errors.emailid}</div>
                    )}
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <input
                      className="contactInput"
                      name="society_name"
                      placeholder="Society Name"
                      value={formik.values.society_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.society_name &&
                      formik.errors.society_name && (
                        <div className="errorField">
                          {formik.errors.society_name}
                        </div>
                      )}
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <input
                      className="contactInput"
                      name="location"
                      placeholder="Select Location"
                      value={formik.values.location}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.location && formik.errors.location && (
                      <div className="errorField">{formik.errors.location}</div>
                    )}
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <input
                      className="contactInput"
                      name="city"
                      placeholder="City"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.city && formik.errors.city && (
                      <div className="errorField">{formik.errors.city}</div>
                    )}
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Button
                      type="submit"
                      className="contactBtn"
                      disabled={!formik.isValid || formik.isSubmitting}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </div>
          </div>
        </div>
      </div>
      <HomeFooter />
    </>
  );
}

export default HomePage;
